import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children }) {
  const { isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!isAdmin) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

export default ProtectedRoute;
